import React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={30} height={19} viewBox="0 0 30 19" {...props}>
      <title>{"Menu"}</title>
      <g fill="#FFF" fillRule="evenodd">
        <path d="M0 0h30v3H0zM0 8h30v3H0zM0 16h30v3H0z" />
      </g>
    </svg>
  )
}

export const MenuIcon = React.memo(SvgComponent)

MenuIcon.displayName = "MenuIcon"
